import React from 'react';
import PropTypes from 'prop-types';
import { Box, Link, Typography } from '@mui/material';
import { formatEnderecoItem } from './jornadaHelpers';

const JornadaGeoLine = ({ item, fotoUrl }) => {
  const endereco = formatEnderecoItem(item?.enderecoJson);
  if (!endereco && !fotoUrl) return null;

  return (
    <Box
      sx={{
        mt: 0.5,
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        minWidth: 0,
      }}
    >
      {endereco ? (
        <Typography
          variant="caption"
          color="text.secondary"
          noWrap
          title={endereco}
          sx={{ flex: 1, minWidth: 0 }}
        >
          {endereco}
        </Typography>
      ) : null}
      {fotoUrl ? (
        <Link
          href={fotoUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          sx={{ flexShrink: 0 }}
        >
          Foto
        </Link>
      ) : null}
    </Box>
  );
};

JornadaGeoLine.propTypes = {
  item: PropTypes.object,
  fotoUrl: PropTypes.string,
};

export default JornadaGeoLine;
